import { appStore } from 'src/mobx/appStore';
import { TTranslate } from 'src/types/main';
import { getTranslate } from './formatter';

// ✅ Checks if the text is only Arabic (letters + digits + spaces + underscores)
const isOnlyArabic = (word: string) => /^[\p{Script=Arabic}\p{N}_\s]+$/u.test(word);

// ✅ Checks if the text is only English (Latin letters + digits + spaces + underscores)
const isOnlyEnglish = (word: string) => /^[\p{Script=Latin}\p{N}_\s]+$/u.test(word);

// ✅ Removes all symbols except Arabic, Latin letters, digits, and spaces, then converts spaces to underscores
const toSnakeCase = (str: string) =>
  str
    .normalize('NFKD')
    .replace(/[^\p{Script=Arabic}\p{Script=Latin}\p{N}\s]/gu, '') // remove symbols
    .trim()
    .replace(/\s+/g, '_')
    .toLowerCase();

export function generateSeoUrl(entity: { id: number; name: TTranslate }) {
  if (!entity) return '';

  const entityId = entity.id;
  const entityName = getTranslate(entity.name) || entity.name?.en || entity.name?.ar || '';

  const base = toSnakeCase(entityName);

  // 🔥 Reject if mixed Arabic and English
  const isArabic = isOnlyArabic(base);
  const isEnglish = isOnlyEnglish(base);

  if (!isArabic && !isEnglish) {
    return entityId;
  }

  // 🔥 Fallback to ID if name is empty after cleaning
  if (!base) {
    return entityId;
  }

  const seoUrl = `${base}_${entityId}`;

  // 🔥 Fallback if SEO URL contains any invalid characters
  if (!appStore.settings?.is_human_readable_url) {
    return entityId;
  }

  return seoUrl;
}

export function getIdFromUrl(url: string): string | number {
  if (/^\d+$/.test(url)) return url;

  const indexOfId = url.lastIndexOf('_');
  if (indexOfId === -1) return url;

  const idPart = url.substring(indexOfId + 1);
  return /^\d+$/.test(idPart) ? idPart : url;
}
